export const sanitizeResumeLocation = (value, evidence = {}) => {
  const result = {...value};
  const keys = ["city", "state", "country", "postalCode", "addressLine1", "addressLine2"];
  keys.forEach(key => {
    if (typeof result[key] !== "string") return;
    const normalized = result[key].trim().replace(/\s+/g, " ").toLowerCase();
    const knownExample = key === "city" ? normalized === "salt lake city"
      : key === "state" ? ["utah", "ut"].includes(normalized)
        : key === "country" && ["united states", "united states of america", "us", "usa"].includes(normalized);
    if (/\(\s*example\s*,\s*not\s*set\s*\)/i.test(result[key]) || (knownExample && evidence?.[key] !== true)) {
      delete result[key];
      if (["city", "state"].includes(key)) { delete result.lat; delete result.lng; }
    }
  });
  return result;
};
